import { loadMessagesForLocale } from 'App'
import { OSSDK } from 'opensolar-sdk'
import { useLocale } from 'ra-core'
import { useEffect, useRef } from 'react'
import { ProposalTemplateTypeEnum } from 'resources/proposalTemplates/types'

const getTranslationMessages = async ({ locale, options }: { locale: string; options?: { phrases?: string[] } }) => {
  const allMessages = (await loadMessagesForLocale(locale)).default
  if (options?.phrases) {
    const message = {}
    options.phrases.forEach((phrase) => {
      if (allMessages[phrase]) message[phrase] = allMessages[phrase]
    })
    return message
  }
  return allMessages
}

const useI18nBindings = ({ active, sdk }: { sdk: OSSDK; active: boolean }) => {
  const appLocale = useLocale()
  const appLocaleRef = useRef(appLocale)
  appLocaleRef.current = appLocale

  useEffect(() => {
    if (!active) return

    const syncLocale = () => {
      const proposalData = sdk.proposal.data.value as {
        locale?: string
        proposalTemplateSettings?: { type?: string }
      } | null
      if (
        proposalData?.proposalTemplateSettings?.type === ProposalTemplateTypeEnum.proposalV2_nonsolar &&
        proposalData.locale
      ) {
        sdk.i18n.locale.value = proposalData.locale
        return
      }
      sdk.i18n.locale.value = appLocaleRef.current
    }

    syncLocale()
    return sdk.proposal.data.add(syncLocale)
  }, [active, sdk, appLocale])

  useEffect(() => {
    if (!active) return

    sdk.i18n.getTranslationMessages.own(getTranslationMessages)
  }, [active])

  sdk.i18n.locale.own()
}

export default useI18nBindings
